//
import Pergunta from '../../shared/entity/Pergunta';
import PerguntaNoPedido from '../../shared/entity/PerguntaNoPedido';
import Resposta from '../../shared/entity/Resposta';
import { criarRespostaNoPedido } from '../../shared/entity/RespostaNoPedido';
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, Alert } from 'react-native';
import { TXT_GG } from '../../constants';
import Divider from '../Generic/Divider';
import ItemResposta from './ItemResposta';
import { useAlert } from '../../redux/alert/alertHooks';
import colors from '../../colors';

type Props = {
  pergunta: Pergunta;
  perguntaNoPedido: PerguntaNoPedido;
  setPerguntaNoPedido: (perguntaNoPedido: PerguntaNoPedido) => void;
};

const ItemPergunta: React.FC<Props> = (props) => {
  const { pergunta, perguntaNoPedido, setPerguntaNoPedido } = props;
  const [esconderValor, setEsconderValor] = useState(false);
  const [mostrarAlert] = useAlert();

  useEffect(() => {
    const temValor = pergunta.respostas.some((resp) => resp.preco > 0);
    setEsconderValor(!temValor);
    if (pergunta.maximoRespostas === 1 && pergunta.obrigatorio) {
      toggleResposta(pergunta.respostas[0]);
    }
  }, []);

  if (!pergunta || pergunta.id !== perguntaNoPedido.perguntaId || !pergunta.respostas) {
    // console.log('TEM ALGO MUITO ERRADO');
    return null;
  }

  const toggleResposta = (resposta: Resposta, quantidade?: number) => {
    // console.log('resposta.descricao', resposta.descricao);
    // console.log('quantidade', quantidade);

    const adicionado = perguntaNoPedido.respostasNoPedido.some(
      (rnp) => rnp.respostaId === resposta.id
    );
    // console.log('adicionado', adicionado);
    const index = perguntaNoPedido.respostasNoPedido.findIndex(
      (rnp) => rnp.respostaId === resposta.id
    );

    if (pergunta.temMaximoRespostas && pergunta.maximoRespostas === 1) {
      // se só pode uma resposta, tiro todas as outras
      if (!adicionado) {
        perguntaNoPedido.respostasNoPedido = [criarRespostaNoPedido(resposta)];
        setPerguntaNoPedido({ ...perguntaNoPedido });
        return true;
      }
    } else {
      const quantidadeRespostas = perguntaNoPedido.respostasNoPedido.reduce(
        (soma, resp) => (soma += resp.quantidade),
        0
      );

      if (adicionado && quantidade > 0) {
        // Já está adicionado e estou mudando a quantidade
        if (
          pergunta.temMaximoRespostas &&
          quantidadeRespostas >= pergunta.maximoRespostas &&
          perguntaNoPedido.respostasNoPedido[index].quantidade < quantidade
        ) {
          mostrarAlert('Ops...', 'Máximo de opções atingido.');
          return false;
        }

        perguntaNoPedido.respostasNoPedido[index].quantidade = quantidade;
        setPerguntaNoPedido({ ...perguntaNoPedido });
        return true;
      } else if (adicionado && !quantidade) {
        // Já está adicionado e estou retirando
        perguntaNoPedido.respostasNoPedido = perguntaNoPedido.respostasNoPedido.filter(
          (resp) => resp.respostaId !== resposta.id
        );
        setPerguntaNoPedido({ ...perguntaNoPedido });
        return true;
      } else {
        // Não está adicionado ainda
        if (pergunta.temMaximoRespostas && quantidadeRespostas >= pergunta.maximoRespostas) {
          mostrarAlert('Ops...', 'Máximo de opções atingido.');
          return false;
        }

        perguntaNoPedido.respostasNoPedido.push(criarRespostaNoPedido(resposta));
        setPerguntaNoPedido({ ...perguntaNoPedido });
        return true;
      }
    }
    return false;
  };

  return (
    <View>
      <View style={styles.viewInfo}>
        <Text style={styles.titulo}>
          {pergunta.descricao}
          {pergunta.obrigatorio ? '*' : ''}
        </Text>

        {pergunta.temMaximoRespostas && (
          <Text style={styles.typoInfo}>MÁX.: {pergunta.maximoRespostas}</Text>
        )}
      </View>

      {pergunta.respostas.map((resposta, i) => (
        <ItemResposta
          key={'resposta' + i}
          resposta={resposta}
          onPress={(res, quant) => toggleResposta(res, quant)}
          adicionado={perguntaNoPedido.respostasNoPedido.some(
            (rnp) => rnp.respostaId === resposta.id
          )}
          radio={pergunta.maximoRespostas === 1}
          esconderValor={esconderValor}
        />
      ))}

      <Divider style={{ marginBottom: 10, marginTop: 10 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  titulo: {
    fontSize: TXT_GG,
    fontWeight: '700'
    // color: colors.darkGrey
  },
  typoInfo: {
    padding: 3,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    color: '#fff',
    backgroundColor: colors.red,
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  viewInfo: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10
  }
});

export default ItemPergunta;
